import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import { initialFormData, initialErrors, fieldValidation, createMerchantData  } from '../../common/helper/form-constants.js';
import DistributorsService from "../../../services/distributors-service.js";
import ConfigService from "../../../services/config-service.js";

import { FormField, SelectField } from './../../common/helper/formFields';

const AddDistributor= () => {
  const [activeTab, setActiveTab] = useState('per_details');
  const [autoGeneratePassword, setAutoGeneratePassword] = useState(true);
  const [formData, setFormData] = useState({ ...initialFormData });
  const [errors, setErrors] = useState({ ...initialErrors });
  const [loading, setLoading] = useState(false);
  const [statesData,setStatesData] = useState([]);
  const [businessTypes,setbusinessTypes] = useState([]);
  const [limitGroups,setlimitGroups] = useState([]);
  const [industryTypes,setindustryTypes] = useState([]);
  const [city,setCity] = useState([]);
  const navigate = useNavigate();
  const [commGroup, setCommGroup] = useState([]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [statesResponse, businessTypeResponse, industriesResponse,limitGroup,commResponse] = await Promise.all([
        ConfigService.getStates(),
        ConfigService.getBusinessType(),
        ConfigService.getIndustries(),
        ConfigService.getLimitGroups(),
        ConfigService.getCommGroups('MERCHANT'),

      ]);
      const states =  statesResponse.data.data.map(state => ({ value: state.id, label: state.state }));
      const business = Object.entries(businessTypeResponse.data.data).map(([key, value]) => ({
        value: key,
        label: value
      }));
      const industries = Object.entries(industriesResponse.data.data).map(([key, value]) => ({
        value: key,
        label: value
      }));
      const limitGroups =  limitGroup.data.data.map(record => ({ value: record.key, label: record.value, is_default: record.is_default }));
      const comm =   commResponse.data.data.map(record => ({ value: record.key, label: record.value, is_default: record.is_default }));
      const defaultLimit = limitGroups.find(item => item.is_default);
      const defaultCommsion = comm.find(item => item.is_default);
      
      setCommGroup(comm);

      setlimitGroups(limitGroups)
      setStatesData(states)
      setbusinessTypes(business)
      setindustryTypes(industries)
      setTimeout(() => {
        setFormData(prevFormData => ({
          ...prevFormData,
         // limit_group_id: defaultLimit ? defaultLimit.value.toString() : '',
          comm_grp_id: defaultCommsion ? defaultCommsion.value.toString() : ''
        }));
      
      }, 100);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
    document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
  }, []);

  const getCities = (stateID) => {
    setLoading(true);
    ConfigService.getCities(stateID)
      .then(response => {
        const cities =  response.data.data.map(city => ({ value: city.id, label: city.city }));
        setCity(cities)
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const validateFields = (fields, formData) => {
    let isValid = true;
    fields.forEach(fieldName => {
      const fieldValue = formData[fieldName];
      if (!fieldValue || !fieldValue.trim()) {
        validateField(fieldName, fieldValue || ''); 
        isValid = false;
      }
    });
    return isValid;
  };

  const handleNext = (current,tab) => {
    let requiredFields = [];
    switch (current) {
      case 'per_details':
        requiredFields = ['email', 'fullName', 'phoneNumber', 'transaction_type', 'comm_grp_id'];
        break;
      case 'address_details':
        requiredFields = ['addressLine1', 'city', 'state', 'postalCode'];
        break;
      case 'business_details':
        requiredFields = [];
        break;
      default:
        break;
    }
  
    if (!validateFields(requiredFields, formData)) return;
  
    setActiveTab(tab);
  };

  const handlePrevious = (tab) => {
    setActiveTab(tab);
  };
  const addMerchantForm = (e) => {
    e.preventDefault();
    let requiredFields = ['adminFullname', 'adminEmail', 'adminPhone','adminPassword'];
    if(autoGeneratePassword){
      requiredFields = ['adminFullname', 'adminEmail', 'adminPhone'];
    }
    if (!validateFields(requiredFields, formData)) return;
      const merchantData = createMerchantData(formData, autoGeneratePassword);
      setLoading(true);
      DistributorsService.registerDistributor(merchantData)
        .then(response => {
          toast.success(MESSAGES.DIST_CREATED);
          navigate('/distributors')
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          try {
            const errorMessage = error.response.data
            toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
          } catch (e){
            toast.error( MESSAGES.SERVER_ERROR)
          }
        });



  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
    if (name === 'state') {
      getCities(value);
    }
    
   
  };
  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value, autoGeneratePassword);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
  };

  const handleAutoGenerate = () => {
    if (!autoGeneratePassword) {
      setErrors(prevErrors => ({ ...prevErrors, adminPassword: '' }));
      setFormData(prevData => ({ ...prevData, adminPassword: '' }));
  }
    setAutoGeneratePassword(!autoGeneratePassword); // Toggle checkbox status

  } 
  return (
    <div>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
    <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Add Distributor</h4>
    <div className="container-fluid ghty" style={{backgroundColor: 'white'}}>
      <form method="post" id="register_form" action="#" className="merchant_form" onSubmit={addMerchantForm}>
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className={`nav-link ${activeTab === 'per_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_per_details">Personal Information</a>
          </li>
          <li className="nav-item tbbtrn">
            <a className={`nav-link ${activeTab === 'address_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_address_details">Address</a>
          </li>
          <li className="nav-item tbbtrn">
            <a className={`nav-link ${activeTab === 'business_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_business_details">Business Information</a>
          </li>
          <li className="nav-item tbbtrn">
            <a className={`nav-link ${activeTab === 'admin_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_admin_details">Admin Credentials</a>
          </li>
        </ul>
        <div className="tab-content" style={{marginTop: '16px'}}>
          <div className={`tab-pane ${activeTab === 'per_details' ? 'active' : 'fade'}`} id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="f_name">FULL NAME</label>
                      <input type="text" className="form-control" id="f_name" placeholder="Enter Full Name" name="f_name" />
                      <span id="error_fname" className="text-danger" /> */}
                       <FormField
                           type="text"
                           isRequierd = {true}
                           id="f_name"
                           name="fullName"
                           label="FULL NAME"
                           placeholder = "Enter Full Name"
                           value={formData.fullName}
                           onChange={handleChange}
                           error={errors.fullName}
                           maxlength = {100}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="email">PHONE NUMBER</label>
                      <input type="number" className="form-control has-error" id="phone_number" placeholder="Enter Phone Number" name="phone_number" />
                      <span id="error_phone_number" className="text-danger">Phone Number is required</span> */}
                      <FormField
                           type="text"
                           isRequierd = {true}
                           id="phone"
                           name="phoneNumber"
                           label="PHONE NUMBER"
                           placeholder = "Enter Phone Number"
                           value={formData.phoneNumber}
                           onChange={handleChange}
                           error={errors.phoneNumber}
                           maxlength = {10}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                          
                          <SelectField 
                            id="comm_grp_id"
                            isRequierd = {true}
                            name="comm_grp_id"
                            label="COMMISSION GROUP"
                            selectedField = "Select Commssion Group"
                            value={formData.comm_grp_id}
                            onChange={handleChange}
                            error={errors.comm_grp_id}
                            options={commGroup}
                            />
                      
                      <span id="error_profiles_gender" className="text-danger" />
                    </div>
                    {/* <div className="form-group frm" style={{textAlign: 'left'}}>
                      
                     <SelectField 
                       id="limit_group"
                       isRequierd = {true}
                       name="limit_group"
                       label="LIMIT GROUP"
                       selectedField = "Select Limit Group"
                       value={formData.limit_group}
                       onChange={handleChange}
                       error={errors.limit_group}
                       options={limitGroups}
                    />
                    </div> */}
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="email">E-MAIL</label>
                      <input type="email" className="form-control" id="email" placeholder="Enter Email" name="email" />
                      <span id="error_email" className="text-danger" /> */}
                       <FormField
                           type="email"
                           isRequierd = {true}
                           id="email"
                           name="email"
                           label="E-mail"
                           placeholder = "Enter Email"
                           value={formData.email}
                           onChange={handleChange}
                           error={errors.email}
                           maxlength = {100}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                       id="transaction_type"
                       isRequierd = {true}
                       name="transaction_type"
                       label="BUSINESS TYPE"
                       selectedField = "Select Business Type"
                       value={formData.transaction_type}
                       onChange={handleChange}
                       error={errors.transaction_type}
                       options={businessTypes}
                    />
                    </div>
                 
                  </div>
                </div>
                <br />
                <div align="left">
                  <button type="button" name="btn_login_details" id="btn_login_details" className="btn ddfg" onClick={() => handleNext('per_details','address_details')}>Next</button>
                </div>
                <br />
              </div>
            </div>
          </div>
          <div className={`tab-pane ${activeTab === 'address_details' ? 'active' : 'fade'}`} id="address_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="f_name">ADDRESS LINE 1</label>
                      <input type="text" className="form-control" id="address_1" placeholder="Enter Address" name="address_1" />
                      <span id="error_address_1" className="text-danger" /> */}
                      <FormField
                           type="text"
                           isRequierd = {true}
                           id="addressLine1"
                           name="addressLine1"
                           label="ADDRESS LINE 1"
                           placeholder = "Enter Address"
                           value={formData.addressLine1}
                           onChange={handleChange}
                           error={errors.addressLine1}
                           maxlength = {50}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                       id="state"
                       isRequierd = {true}
                       name="state"
                       label="STATE"
                       selectedField = "Select State"
                       value={formData.state}
                       onChange={handleChange}
                       error={errors.state}
                       options={statesData}
                    />
                      {/* <label className="required" htmlFor="City">CITY</label>
                      <select name="city" className="drp" id="city">
                        <option value>Select City</option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                      </select>
                      <span id="error_city" className="text-danger" /> */}
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {true}
                           id="postalCode"
                           name="postalCode"
                           label="POSTAL CODE"
                           placeholder = "Enter Postal Code"
                           value={formData.postalCode}
                           onChange={handleChange}
                           error={errors.postalCode}
                           maxlength = {6}
                        />
                      {/* <label className="required" htmlFor="email">POSTAL CODE</label>
                      <input type="email" className="form-control" id="postal_code" placeholder="Enter Postal Code" name="email" />
                      <span id="error_postal_code" className="text-danger" /> */}
                    </div>
                    {/* <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label className="required" htmlFor="Country">COUNTTRY</label>
                      <select name="country" className="drp" id="country">
                        <option value>Select Country</option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                      </select>
                      <span id="error_country" className="text-danger" />
                    </div> */}
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {false}
                           id="addressLine2"
                           name="addressLine2"
                           label="ADDRESS LINE 2"
                           placeholder = "Enter Address"
                           value={formData.addressLine2}
                           onChange={handleChange}
                           error={errors.addressLine2}
                           maxlength = {50}
                        />
                      {/* <label className="required" htmlFor="email">ADDRESS LINE 2</label>
                      <input type="email" className="form-control" id="address_2" placeholder="Enter Address" name="email" />
                      <span id="error_address_2" className="text-danger" /> */}
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="Transaction">STATE/PROVINCE</label>
                      <select name="state" className="drp" id="state">
                        <option value>Select State</option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                      </select>
                      <span id="error_state" className="text-danger" /> */}
                       <SelectField 
                       id="city"
                       isRequierd = {true}
                       name="city"
                       label="CITY"
                       selectedField = "Select City"
                       value={formData.city}
                       onChange={handleChange}
                       error={errors.city}
                       options={city}
                    />
                      
                    </div>
                
                  </div>
                </div>
                <br />
                <div align="left">
                  <button type="button" name="previous_btn_personal_details" id="previous_btn_personal_details" className="btn ddfgg" onClick={() => handlePrevious('per_details')}>Previous</button>
                  <button type="button" name="btn_personal_details" id="btn_personal_details" className="btn ddfg "onClick={() => handleNext('address_details','business_details')}>Next</button>
                </div>
                <br />
              </div>
            </div>
          </div>
          <div className={`tab-pane ${activeTab === 'business_details' ? 'active' : 'fade'}`}  id="business_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label htmlFor="f_name">BUSINESS REGISTRATION NUMBER</label>
                      <input type="text" className="form-control" id="bus_nunber" placeholder="Enter Business Registration Number" name="f_name" /> */}
                      {/*<span id="error_business_number" class="text-danger"></span>*/}

                      <FormField
                           type="text"
                           isRequierd = {false}
                           id="registrationNumber"
                           name="registrationNumber"
                           label="BUSINESS REGISTRATION NUMBER"
                           placeholder = "Enter Business Registration Number"
                           value={formData.registrationNumber}
                           onChange={handleChange}
                           error={errors.registrationNumber}
                           maxlength = {20}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="Industry">INDUSTRY TYPE</label>
                      {/* <select name="industry_type" className="drp" id="industry_type">
                        <option value>Select Industry Type</option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
               
                      </select> */}
                      {/*<span id="error_industry_type" class="text-danger"></span>*/}
                      <SelectField 
                       id="industry"
                       isRequierd = {false}
                       name="industry"
                       label="INDUSTRY TYPE"
                       selectedField = "Select Industry Type"
                       value={formData.industry}
                       onChange={handleChange}
                       error={errors.industry}
                       options={industryTypes}
                    />
                    </div>
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label htmlFor="email">DESCRIPTION</label>
                      <input type="email" className="form-control" id="email" placeholder="Enter Description" name="email" /> */}
                      {/*<span id="error_email" class="text-danger"></span>*/}

                      <FormField
                           type="text"
                           isRequierd = {false}
                           id="description"
                           name="description"
                           label="DESCRIPTION"
                           placeholder = "Enter DESCRIPTION"
                           value={formData.description}
                           onChange={handleChange}
                           error={errors.description}
                           maxlength = {50}
                        />
                    </div>
                  </div>
                </div>
                <br />
                {/*<div align="center">*/}
                {/*  <button type="button" name="previous_btn_contact_details" id="previous_btn_contact_details" class="btn btn-default btn-lg">Previous</button>*/}
                {/*  <button type="button" name="btn_contact_details" id="btn_contact_details" class="btn btn-success btn-lg">Register</button>*/}
                {/*</div>*/}
                <div align="left">
                  <button type="button" name="previous_btn_contact_details" id="previous_btn_contact_details" className="btn ddfgg"  onClick={() => handlePrevious('address_details')}>Previous</button>
                  <button type="button" name="btn_admin_details" id="btn_admin_details" className="btn ddfg" onClick={() => handleNext('business_details','admin_details')}>Next</button>
                </div>
                <br />
              </div>
            </div>
          </div>
          <div className={`tab-pane ${activeTab === 'admin_details' ? 'active' : 'fade'}`}  id="admin_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="f_name">ADMIN FULL NAME</label>
                      <input type="text" className="form-control" id="admin_name" placeholder="Enter Admin Full Name" name="address_1" />
                      <span id="error_admin_name" className="text-danger" /> */}
                      <FormField
                           type="text"
                           isRequierd = {true}
                           id="adminFullname"
                           name="adminFullname"
                           label="ADMIN FULL NAME"
                           placeholder = "Enter Full Name"
                           value={formData.adminFullname}
                           onChange={handleChange}
                           error={errors.adminFullname}
                           maxlength = {20}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="email">MERCHANT ADMIN EMAIL-ID</label>
                      <input type="email" className="form-control" id="admin_email" placeholder="Enter Admin Email" name="email" />
                      <span id="error_admin_email" className="text-danger" /> */}
                      <FormField
                           type="text"
                           isRequierd = {true}
                           id="adminEmail"
                           name="adminEmail"
                           label="ADMIN EMAIL-ID"
                           placeholder = "Enter email id"
                           value={formData.adminEmail}
                           onChange={handleChange}
                           error={errors.adminEmail}
                        />
                    </div>
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="email">ADMIN PHONE NUMBER</label>
                      <input type="number" className="form-control" id="admin_phone" placeholder="Enter Admin Phone Number" name="email" />
                      <span id="error_admin_phone" className="text-danger" /> */}
                      <FormField
                           type="text"
                           isRequierd = {true}
                           id="adminPhone"
                           name="adminPhone"
                           label="ADMIN PHONE NUMBER"
                           placeholder = "Enter Phone No."
                           value={formData.adminPhone}
                           onChange={handleChange}
                           error={errors.adminPhone}
                           maxlength = {10}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      {/* <label className="required" htmlFor="email">MERCHANT ADMIN PASSWORD</label>
                      <input type="password" className="form-control nhjgf" id="admin_password" defaultValue="password" name="admin_password" disabled /> */}

                        <FormField
                           type="password"
                           isRequierd = {true}
                           id="adminPassword"
                           name="adminPassword"
                           label="ADMIN PASSWORD"
                           placeholder = "Enter password"
                           value={formData.adminPassword}
                           onChange={handleChange}
                           error={errors.adminPassword}
                           disabled={autoGeneratePassword}
                           maxlength={15}
                        />
                      <i style={{display: 'none'}} className="toggle-password fa fa-fw fa-eye-slash" />
                      <span id="error_admin_password" className="text-danger" />
                      <p><input type="checkbox" onChange={handleAutoGenerate} style={{position: 'absolute'}} className="fchk myCheckbox"  defaultChecked={autoGeneratePassword} />
                        <span style={{marginLeft: '30px', color: '#495a69', marginTop: '6px', position: 'absolute', fontSize: '13px', fontWeight: 600}}>Auto Generate Password</span></p>
                    </div>
                  </div>
                </div>
                <br />
                <div align="left">
                  <button type="button" name="previous_btn_amin_details" id="previous_btn_amin_details" className="btn ddfgg"  onClick={() => handlePrevious('business_details')}>Previous</button>
                  <button type="sumbit" name="btn_asubmit" id="btn_asubmit" className="btn ddfg">Submit</button>
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  </div>
  );


  }


export default withAuth(AddDistributor);
